import FJTextBaseEditingPreviewManager from '../../core/textBasedEditing/FJTextBaseEditingPreviewManager.js';

const FJTextBaseEditPreviewStore = {
    init: async function (url, type) {
        await FJTextBaseEditingPreviewManager.init(url, type);
        const sourceInfo = FJTextBaseEditingPreviewManager.getSourceInfo();
        return sourceInfo;
    },

    /**
     * @desc 更新缩略图 并返回缩略图链接
     * @param {string} url
     * @returns {Promise<string>}
     */
    updateThumbnailBlobUrl: async function (thumbnailSize) {
        return await FJTextBaseEditingPreviewManager.updateThumbnailBlobUrl(thumbnailSize);
    },

    /**
     * @desc 获取缩略图 - 视频的首帧组成的缩略图
     * @returns {Promise<string>}
     * @param {Function} callback
     */
    getThumbnailBlobUrlByFirstFrame: async function (thumbnailSize, callback) {
        FJTextBaseEditingPreviewManager.getThumbnailBlobUrlByFirstFrame(thumbnailSize, callback);
    },

    /**
     * @desc 设置视频画布
     * @param {HTMLCanvasElement} canvas
     */
    setVideoCanvas: function (canvas) {
        FJTextBaseEditingPreviewManager.setVideoCanvas(canvas);
    },

    /**
     * @desc seek
     * @param {number} time
     */
    seek: async function (time) {
        await FJTextBaseEditingPreviewManager.seek(time);
    },

    /**
     * @desc 暂停
     */
    pause: async function () {
        await FJTextBaseEditingPreviewManager.pause();
    },

    /**
     * @desc 播放
     */
    play: function (callback, pauseCallback) {
        FJTextBaseEditingPreviewManager.play(callback, pauseCallback);
    },

    /**
     * @desc 绘制视频画布
     */
    drawVideoCanvas: function () {
        FJTextBaseEditingPreviewManager.drawVideoCanvas();
    },

    /**
     * @desc 设置分割时间列表
     * @param {Array} splitTimeList
     */
    setSplitTimeList: function (splitTimeList) {
        FJTextBaseEditingPreviewManager.setSplitTimeList(splitTimeList);
    },

    /**
     * @desc 设置时间数据
     * @param {number} startTime
     * @param {number} endTime
     */
    setTimeData: function (startTime, endTime) {
        FJTextBaseEditingPreviewManager.setTimeData(startTime, endTime);
    },

    /**
     * @desc 清除
     */
    clear: function () {
        FJTextBaseEditingPreviewManager.clear();
    },

    resizeView: function () {
        FJTextBaseEditingPreviewManager.initVideoRect();
        FJTextBaseEditingPreviewManager.drawVideoCanvas();
    },
};

export default FJTextBaseEditPreviewStore;
